import { render, staticRenderFns } from "./close-search-svg.vue?vue&type=template&id=9cf6da18&scoped=true"
import script from "./close-search-svg.vue?vue&type=script&lang=js"
export * from "./close-search-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf6da18",
  null
  
)

export default component.exports